  import React from 'react';
  import { IoIosArrowBack } from "react-icons/io";
  import { IoIosArrowForward } from "react-icons/io";

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

    return (
      <div className="pagination-container my-12 flex items-center justify-center text-white w-full">
        {/* Butonul pentru săgeata spre stânga */}
        <button
          className="pagination-btn_arrow mr-[0.5rem] text-white w-10 h-10 
        hover:transform hover:scale-105 hover:text-white duration-500
            flex items-center justify-center "
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <IoIosArrowBack />
        </button>

        {/* Paginile numerotate */}
        {pages.map((page, index) => (
          <button
            key={page}
            className={`pagination-btn ${
              currentPage === page ? 'active border w-8 h-8 border-white rounded-full duration-500' : ''
            } ${index > 0 ? 'ml-2' : ''}`} 
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}

        {/* Butonul pentru săgeata spre dreapta */}
        <button
          className="pagination-btn_arrow ml-[0.5rem] text-white w-10 h-10 
        hover:transform hover:scale-105 hover:text-white duration-500
            flex items-center justify-center "
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <IoIosArrowForward />
        </button>
      </div>
    );
  };

  export default Pagination;
